import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TrackerQueryDeleteComponent } from '../trackerQueryDelete/tracker.query.delete.component'
import { TrackerFilterService } from '../../../services/tracker.filter.service';
import { TrackerQueryService } from '../../../services/tracker.query.service';
import { TrackerRest } from '../../../services/tracker.rest';
import { StateService } from '@uirouter/angular';
import { UiService } from '../../../../../core/services/core.ui.service';
import { UserService } from '../../../../../core/services/core.user.service';

@Component({
  selector: 'tracker-query-edit',
  template: require('./tracker.query.edit.component.html'),
})
export class TrackerQueryEditComponent implements OnInit {
  @Input() tracker: any;
  @Input() query: any;
  @Input() projectMenu: any;

  loading: boolean = true;
  currentFilters: any[] = [];
  fieldsToDisplay: any = {};
  sortByField: any = {};
  dateFields: any;
  openDate: any = { startDate: '', endDate: '' };
  closeDate: any = { startDate: '', endDate: '' };
  modDate: any = { startDate: '', endDate: '' };
  activeEditTab: string = 'query-main';
  isNew: boolean = false;
  isMine: boolean = false;
  isAdmin: boolean = false;
  canEdit: boolean = false;
  canDelete: boolean = false;
  _textsearch: any;
  summary: any;
  submittedBy: any;

  constructor(
    private modalService: NgbModal,
    private trackerFilterService: TrackerFilterService,
    private trackerQueryService: TrackerQueryService,
    protected stateService: StateService, 
    private uiService: UiService,
    private trackerRest: TrackerRest,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.currentFilters = [];
    this.fieldsToDisplay = {};
    this.sortByField = {};

    this.isNew = _.get(this, 'query.id', 0) === 0;
    this.isMine = _.get(this.query, 'user.id', 0) === this.userService.session.getUser().id;
    this.isAdmin = _.get(this, 'projectMenu.admin', false);
    this.canEdit = this.isNew || this.isMine || this.isAdmin;
    this.canDelete = !this.isNew && this.canEdit;

    this.trackerFilterService.setup(this.tracker);

    this.trackerFilterService.get({ tracker: this.tracker }, this.tracker.id).then((filters: any) => {

      this.currentFilters = _.concat(filters.main_fields, filters.extra_fields);
      this.currentFilters = this.trackerQueryService.mapQueryFieldsToFilters(this.currentFilters, this.query);
      this.sortByField = this.trackerQueryService.mapQuerySortByFieldToFilter(this.tracker, this.query);
      this.dateFields = this.trackerQueryService.mapQueryDatesToQueryDateObject(this.query);

      this._textsearch = _.find(this.currentFilters, { alias: '_textsearch' });
      this.summary = _.find(this.currentFilters, { alias: 'summary' });
      this.submittedBy = _.find(this.currentFilters, { alias: 'submittedBy' });

      this.openDate = {
        startDate: this.dateFields.FIELD_OPENDATE.startDate,
        endDate: this.dateFields.FIELD_OPENDATE.endDate,
      };
      this.closeDate = {
        startDate: this.dateFields.FIELD_CLOSEDATE.startDate,
        endDate: this.dateFields.FIELD_CLOSEDATE.endDate,
      };
      this.modDate = {
        startDate: this.dateFields.FIELD_MODDATE.startDate,
        endDate: this.dateFields.FIELD_MODDATE.endDate,
      };

      _.filter(this.currentFilters, (filter: any) => {
        return ![9, 10, 11, 20, 22, 24].includes(filter.fieldType);
      }).forEach((filter: any) => {
        if (_.isEmpty(filter.fieldData)) {
          filter.fieldData = [_.find(filter.fieldElements, { id: 0 })];
        }
      });

      this.loading = false;
    });
  }

  saveQuery() {
    if (!(this.query.id > 0)) {
      this.query.tracker = this.tracker;
      this.query.user = this.userService.session.getUser();
    }

    this.dateFields.FIELD_OPENDATE.startDate = this.openDate.startDate;
    this.dateFields.FIELD_OPENDATE.endDate = this.openDate.endDate;
    this.dateFields.FIELD_CLOSEDATE.startDate = this.closeDate.startDate;
    this.dateFields.FIELD_CLOSEDATE.endDate = this.closeDate.endDate;
    this.dateFields.FIELD_MODDATE.startDate = this.modDate.startDate;
    this.dateFields.FIELD_MODDATE.endDate = this.modDate.endDate;

    this.trackerQueryService.mapFiltersToQueryFields(this.currentFilters, this.query);
    this.trackerQueryService.mapQueryDatesObjectToQuery(this.dateFields, this.query);
    this.trackerQueryService.mapFieldsToDisplayToQuery(this.fieldsToDisplay, this.query);
    this.trackerQueryService.mapFieldSortByToQuery(this.sortByField, this.query);

    this.trackerRest.postQuery(this.query.tracker.id, this.query.id, this.query)
      .then(() => {
        this.uiService.message.showSuccess("Query " + this.query.queryName + " has been successfully saved");
        this.close();
      })
      .catch(() => {
        this.uiService.message.showError("There were one or more errors when saving Query " + this.query.queryName);
      });
  }

  showDeleteQuery() {
    const modalRef = this.modalService.open(TrackerQueryDeleteComponent);
    modalRef.componentInstance.query = this.query;
    modalRef.componentInstance.close.subscribe(() => {
	    modalRef.close();
      this.close();
    });
  }

  close() {
    this.stateService.go("home.project.summary.query");
  }
}
